import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '../../../app.state';
import { Customer } from '../../../shared/models/customer/customer.model';
import { CustomerService } from '../../../shared/services/customer/customer.service';
import { User } from '../../../shared/services/user/models/user.model';
import { UserService } from '../../../shared/services/user/user.service';
import { UserRoutes } from '../../models/user-routes.model';

@Injectable()
export class UserRouteService {
    public userRoutes: UserRoutes;

    public constructor(private readonly userService: UserService,
                       private readonly customerService: CustomerService,
                       private readonly router: Router,
                       private readonly appState: AppState,
    ) {
        this.userRoutes = this.appState.userRoutes$();
    }

    public loadUserRoutes(user: User, customer: Customer): UserRoutes {
        if (!user || !customer) {
            return;
        }

        const userRoutes = new UserRoutes();
        const isUSCustomer = this.customerService.isUSCustomer(customer);
        const isEUCustomer = this.customerService.isEUCustomer(customer);
        const isHKCustomer = this.customerService.isHKCustomer(customer);
        const isEUUser = this.userService.isEUUser(user.CountryCode);

        if (!user.IsGuest && isUSCustomer) {
            userRoutes.ECommerce = true;
        }


        if (user.IsGuest && !isEUCustomer) {
            userRoutes.Claims = true;
            userRoutes.FileClaim = true;
            userRoutes.ClaimFAQ = true;
            userRoutes.ClaimsDashboard = true;
            userRoutes.ContactUs = true;
            userRoutes.Dashboard = true;
            userRoutes.DeliveryDefenseSignUp = true;
            userRoutes.DeliveryDefenseFAQ = true;
            userRoutes.ShippingIntelligence = true;
            userRoutes.ScoreHistory = true;
            userRoutes.AddressConfidenceTool = true;
            userRoutes.ManageSubscriptions = true;
            userRoutes.TrackShipments = false;
        }

        if (!user.IsGuest && !user.IsEuropean) {
            userRoutes.ReportHistory = true;
            userRoutes.EndOfDayReports = true;
            userRoutes.RecentShipment = true;
            userRoutes.Claims = true;
            userRoutes.FileClaim = true;
            userRoutes.ClaimFAQ = true;
            userRoutes.ClaimsDashboard = true;
            userRoutes.ContactUs = true;
            userRoutes.SupplyOrder = true;
            userRoutes.BillingHistory = true;
            userRoutes.CreditHistory = true;
            userRoutes.PackageInvestigation = true;
            userRoutes.PaymentHistory = true;
            userRoutes.ManageCreditCard = true;
            userRoutes.AddressBook = true;
            userRoutes.UserSettings = true;
            userRoutes.CompanyProfile = true;
            userRoutes.ManageLocations = true;
            userRoutes.NotifyTemplates = true;
            userRoutes.AddCreditCard = true;
            userRoutes.BIR = true;
            userRoutes.Dashboard = true;
            userRoutes.FAQs = true;
            userRoutes.DeliveryDefenseSignUp = true;
            userRoutes.DeliveryDefenseFAQ = true;
            userRoutes.ShippingIntelligence = true;
            userRoutes.ScoreHistory = true;
            userRoutes.AddressConfidenceTool = true;
            userRoutes.ManageSubscriptions = true;

            if (user.ShowRates) {
                userRoutes.CostEstimator = true;
            }
        }

        if (user.IsEuropean && !isEUCustomer) {
            userRoutes.ShipmentHistory = true;
            userRoutes.ReportHistory = true;
            userRoutes.EndOfDayReports = true;
            userRoutes.TrackShipments = true;
            userRoutes.Claims = true;
            userRoutes.FileClaim = true;
            userRoutes.ClaimFAQ = true;
            userRoutes.ClaimsDashboard = true;
            userRoutes.ContactUs = true;
            userRoutes.BillingHistory = true;
            userRoutes.CreditHistory = true;
            userRoutes.PaymentHistory = true;
            userRoutes.ManageCreditCard = true;
            userRoutes.AddressBook = true;
            userRoutes.ManageLocations = true;
            userRoutes.UserSettings = true;
            userRoutes.CompanyProfile = true;
            userRoutes.ManageLocations = true;
            userRoutes.AddCreditCard = true;
            userRoutes.BIR = true;
            userRoutes.Dashboard = true;

        }

        if (isHKCustomer) {
            userRoutes.PaymentHistory = false;
            userRoutes.ManageCreditCard = false;
        }

        if (isEUCustomer) {
            userRoutes.ShipmentHistory = true;
            userRoutes.ReportHistory = true;
            userRoutes.EndOfDayReports = true;
            userRoutes.TrackShipments = true;
            userRoutes.Claims = true;
            userRoutes.FileClaim = true;
            userRoutes.ClaimFAQ = true;
            userRoutes.ClaimsDashboard = true;
            userRoutes.ContactUs = true;
            userRoutes.BillingHistory = true;
            userRoutes.CreditHistory = true;
            userRoutes.AddressBook = true;
            userRoutes.UserSettings = true;
            userRoutes.CompanyProfile = true;
            userRoutes.ManageLocations = true;
            userRoutes.BIR = true;
            userRoutes.Dashboard = true;
        }

        if (isEUUser) {
            userRoutes.RestrictedZipCodes = false;
            userRoutes.NotifyTemplates = true;
        }

        if (user.IsAdmin) {
            userRoutes.ShipmentHistory = true;
            userRoutes.TrackShipments = true;
            userRoutes.ReportHistory = true;
            userRoutes.EndOfDayReports = true;
            userRoutes.TrackShipments = true;

            if (!user.IsGuest) {
                userRoutes.ManageUsers = true;
            }
            if (!isEUCustomer && !user.IsEuropean) {
                userRoutes.SupplyOrder = true;
                userRoutes.SchedulePickup = true;
            }
        }

        userRoutes.Support = true;

        if (customer.IsAllowedToReport) {
            userRoutes.ShipReport = true;
        }

        if (customer.IsAllowedToShip) {
            if (user.IsFedexDomestic || user.IsFedexInternational) {
                userRoutes.ShipFedex = true;
                userRoutes.Ship = true;
                userRoutes.RecentShipment = true;
                if (!user.IsGuest) {
                    userRoutes.ShipmentHistory = true;
                    userRoutes.TrackShipments = true;
                    userRoutes.SchedulePickup = true;
                    userRoutes.RewardShip = true;
                    userRoutes.DWRewardShip = true;
                    userRoutes.SavedQuotes = true;
                }
            }

            if (user.IsUPSDomestic || user.IsUPSInternational) {
                userRoutes.ShipUPS = true;
                userRoutes.Ship = true;
                userRoutes.RecentShipment = true;
                if (!user.IsGuest) {
                    userRoutes.ShipmentHistory = true;
                    userRoutes.TrackShipments = true;
                    userRoutes.WorldShipUpload = true;
                    userRoutes.SchedulePickup = true;
                    userRoutes.SavedQuotes = true;

                    if (!isEUCustomer) {
                        userRoutes.RewardShip = true;
                        userRoutes.DWRewardShip = true;
                    }
                }
            }

            // Change the condition for allowing an access to "Support Documents".
            // User's carrier should no longer be checked.
            if (!user.IsGuest && !user.IsEuropean) {
                userRoutes.SupportDocuments = true;
            }
        }

        if (user.IsFirstLogon) {
            userRoutes.TermsUnsigned = true;
        }

        this.userRoutes = userRoutes;

        return userRoutes;
    }

    public async canAccessRoute(user: User, customer: Customer, routeName: string): Promise<boolean> {
        if (!this.userRoutes) {
            const user = this.appState.user$();
            const customer = this.appState.customer$();

            this.userRoutes = this.loadUserRoutes(user, customer);
            this.appState.userRoutes$.set(this.userRoutes);
        }

        const isHandled = await this.handleUserStatuses(user, customer, routeName);
        if (isHandled) {
            return true;
        }

        return Promise.resolve(!!this.userRoutes[routeName]);
    }

    /**
     * True if a user can access the route or the case has been handled (redirected).
     * False if the check should be further handled by the caller.
     * @param user
     * @param customer
     * @param routeName
     * @private
     */
    private async handleUserStatuses(user: User, customer: Customer, routeName: string): Promise<boolean> {
        const isAccountClosed = [0, 2, 3, 4, 12, 13, 14].includes(+customer.Status);
        if (isAccountClosed) {
            return this.handleClosedAccount(routeName);
        }

        const isAccountSuspended = [11].includes(+customer.Status);
        if (isAccountSuspended) {
            return this.handleSuspendedAccount(user, customer, routeName);
        }

        if (user.IsFirstLogon) {
            return this.handleFirstLogonUser(routeName);
        }

        return false;
    }

    private async handleFirstLogonUser(routeName: string): Promise<boolean> {
        const allowedRouteName = 'TermsUnsigned';
        this.userRoutes[allowedRouteName] = true;

        if (routeName === allowedRouteName) {
            return true;
        }

        return this.router.navigate(['/terms/terms-conditions']);
    }

    private async handleClosedAccount(routeName: string): Promise<boolean> {
        const allowedRouteName = 'AccountClosed';
        this.userRoutes[allowedRouteName] = true;

        if (routeName === allowedRouteName) {
            return true;
        }

        return this.router.navigate(['/account-closed']);
    }

    private async handleSuspendedAccount(user: User, customer: Customer, routeName: string): Promise<boolean> {
        const forbiddenRouteNames = [
            'Ship',
            'ReportHistory',
            'WorldShipUpload',
        ];
        this.userRoutes['AccountSuspended'] = true;

        if (!forbiddenRouteNames.includes(routeName)) {
            return true;
        }

        return this.router.navigate(['/account-suspended']);
    }
}
